'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_patterns_ZapierLogoSymbol_svgs_SymbolSize20 = require('./svgs/SymbolSize20.cjs.js');
const components_patterns_ZapierLogoSymbol_svgs_SymbolSize24 = require('./svgs/SymbolSize24.cjs.js');
const components_patterns_ZapierLogoSymbol_svgs_SymbolSize30 = require('./svgs/SymbolSize30.cjs.js');
const components_patterns_ZapierLogoSymbol_svgs_SymbolSize36 = require('./svgs/SymbolSize36.cjs.js');
const components_patterns_ZapierLogoSymbol_svgs_SymbolSize40 = require('./svgs/SymbolSize40.cjs.js');
const components_patterns_ZapierLogoSymbol_svgs_SymbolSize48 = require('./svgs/SymbolSize48.cjs.js');
const components_patterns_ZapierLogoSymbol_svgs_SymbolSize60 = require('./svgs/SymbolSize60.cjs.js');
const components_patterns_ZapierLogoSymbol_svgs_SymbolSize80 = require('./svgs/SymbolSize80.cjs.js');
const components_patterns_ZapierLogoSymbol_svgs_SymbolSize120 = require('./svgs/SymbolSize120.cjs.js');
const components_patterns_ZapierLogoSymbol_svgs_SymbolSize150 = require('./svgs/SymbolSize150.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const getLogo = (size) => {
  switch (size) {
    case "small":
      return React__default.default.createElement(components_patterns_ZapierLogoSymbol_svgs_SymbolSize24.SymbolSize24, null);
    case "medium":
      return React__default.default.createElement(components_patterns_ZapierLogoSymbol_svgs_SymbolSize36.SymbolSize36, null);
    case "large":
      return React__default.default.createElement(components_patterns_ZapierLogoSymbol_svgs_SymbolSize48.SymbolSize48, null);
    case 20:
      return React__default.default.createElement(components_patterns_ZapierLogoSymbol_svgs_SymbolSize20.SymbolSize20, null);
    case 30:
      return React__default.default.createElement(components_patterns_ZapierLogoSymbol_svgs_SymbolSize30.SymbolSize30, null);
    case 40:
      return React__default.default.createElement(components_patterns_ZapierLogoSymbol_svgs_SymbolSize40.SymbolSize40, null);
    case 60:
      return React__default.default.createElement(components_patterns_ZapierLogoSymbol_svgs_SymbolSize60.SymbolSize60, null);
    case 80:
      return React__default.default.createElement(components_patterns_ZapierLogoSymbol_svgs_SymbolSize80.SymbolSize80, null);
    case 120:
      return React__default.default.createElement(components_patterns_ZapierLogoSymbol_svgs_SymbolSize120.SymbolSize120, null);
    case 150:
      return React__default.default.createElement(components_patterns_ZapierLogoSymbol_svgs_SymbolSize150.SymbolSize150, null);
    default:
      return React__default.default.createElement(components_patterns_ZapierLogoSymbol_svgs_SymbolSize36.SymbolSize36, null);
  }
};
const ZapierLogoSymbol = ({ size = 40 }) => {
  return getLogo(size);
};

exports.ZapierLogoSymbol = ZapierLogoSymbol;
//# sourceMappingURL=ZapierLogoSymbol.cjs.js.map
